import FeedMapping from './FeedMapping';

export default FeedMapping;
